import type { SVGProps } from 'react'

export default function HeroGlyphLine(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M23.4284 3.42856H20.5713V40.5715H23.4284V3.42856Z" stroke="#3D1B3C" strokeWidth="2.85714" />
		</svg>
	)
}
